import CapacityHero from "./CapacityHero";
import CapacityOperations from "./CapacityOperations";
import CapacityBenefits from "./CapacityBenefits";
import CapacityBusiness from "./CapacityBusiness";

const CapacityPlanning = () => {
    return(
<>
<CapacityHero />
<CapacityOperations />
<CapacityBenefits />
<CapacityBusiness />
</>
    );
};

export default CapacityPlanning;